import type { GuidePageId } from './guideContent';
import communities from './art/communities.svg';
import timeline from './art/timeline.svg';
import roles from './art/roles.svg';
import mutual from './art/mutual.svg';
import highRisk from './art/high-risk.svg';
import strongTies from './art/strong-ties.svg';
import handshakes from './art/handshakes.svg';
import crossPlatform from './art/cross-platform.svg';

// Getting started tile illustrations (designer's illustrations/0N-*.svg, 320×240,
// no text). Loaded as <img> URLs rather than inline SVG: they all reuse the
// same ids for their grid and glow defs. The delivery ships the same drawing
// under several use-case ids, hence the shared files.
export const GUIDE_ART: Partial<Record<GuidePageId, string>> = {
  'uc-communities': communities,
  'uc-spread': timeline,
  'uc-period': timeline,
  'uc-roles': roles,
  'uc-closest': roles,
  'uc-mixed': mutual,
  'uc-mutual': mutual,
  'uc-hra': highRisk,
  'uc-strong-ties': strongTies,
  'uc-handshakes': handshakes,
  'uc-cross-platform': crossPlatform,
};
